import React, { useState, useEffect } from 'react';
import Iconify from 'src/components/Iconify';
import { Tooltip } from '@mui/material';

const WhatsAppCountdownTimer = ({ dataUltimaMensagem }) => {
  const [timeLeft, setTimeLeft] = useState(null);
  const [isExpired, setIsExpired] = useState(false);

  useEffect(() => {
    if (!dataUltimaMensagem) return;

    const calculateTimeLeft = () => {
      const now = new Date();
      const lastMessageDate = new Date(dataUltimaMensagem);
      
      // Adiciona 24 horas à data da última mensagem
      const expirationDate = new Date(lastMessageDate.getTime() + (24 * 60 * 60 * 1000));
      
      const difference = expirationDate.getTime() - now.getTime();
      
      if (difference <= 0) {
        setIsExpired(true);
        setTimeLeft(null);
        return;
      }

      setIsExpired(false);
      
      const hours = Math.floor(difference / (1000 * 60 * 60));
      const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((difference % (1000 * 60)) / 1000);

      setTimeLeft({
        hours: hours.toString().padStart(2, '0'),
        minutes: minutes.toString().padStart(2, '0'),
        seconds: seconds.toString().padStart(2, '0')
      });
    };

    // Calcula imediatamente
    calculateTimeLeft();

    // Atualiza a cada segundo
    const interval = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(interval);
  }, [dataUltimaMensagem]);

  if (!dataUltimaMensagem || isExpired) {
    return null;
  }

  if (!timeLeft) {
    return null;
  }

  const getColorClass = () => {
    const totalMinutes = parseInt(timeLeft.hours) * 60 + parseInt(timeLeft.minutes);
    
    if (totalMinutes <= 60) {
      return 'text-red-600'; // Vermelho quando restam menos de 1 hora
    } else if (totalMinutes <= 180) {
      return 'text-orange-600'; // Laranja quando restam menos de 3 horas
    } else {
      return 'text-green-600'; // Verde para mais de 3 horas
    }
  };

  const getIconColor = () => {
    const totalMinutes = parseInt(timeLeft.hours) * 60 + parseInt(timeLeft.minutes);
    
    if (totalMinutes <= 60) {
      return 'error'; // Vermelho quando restam menos de 1 hora
    } else if (totalMinutes <= 180) {
      return 'warning'; // Laranja quando restam menos de 3 horas
    } else {
      return 'success'; // Verde para mais de 3 horas
    }
  };

  return (
    <Tooltip title="Janela de tempo de 24h para enviar mensagens no WhatsApp Business">
      <div className="ml-2 flex items-center gap-1 px-2 py-1 bg-blue-50 border border-blue-200 rounded-md">
        <Iconify 
          icon="mingcute:time-line" 
          color={getIconColor()}
          width={14} 
          height={14} 
        />
        <span className={`text-xs font-medium ${getColorClass()}`}>
          {timeLeft.hours}:{timeLeft.minutes}
        </span>
      </div>
    </Tooltip>
  );
};

export default WhatsAppCountdownTimer;

